<script>
export default {
  name: 'GsCalendarItem',
  props: {
    day: {
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    otherMonth: {
      type: Boolean,
      default: false,
    },
    past: {
      type: Boolean,
      default: false,
    },
    future: {
      type: Boolean,
      default: false,
    },
    long: {
      type: Boolean,
      default: false,
    },
    overview: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Array,
      default: () => [],
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getTotals() {
      if (this.content) {
        const result = this.content.reduce((acc, cur) => {
          let total = acc;

          if (cur.itemType === 'datesETA') {
            total += cur.stepCashRequestEstimatedValue;
          }

          if (cur.itemType === 'estimatedStepCashRequest') {
            total += cur.estimatedStepCashRequestEstimatedValue;
          }

          if (cur.itemType === 'invoice') {
            for (let i = 0; i < cur.invoices.length; i += 1) {
              const invoice = cur.invoices[i];

              if (cur.itemInvoice === invoice.id) {
                if (invoice.installments && invoice.installments.length > 0) {
                  for (let j = 0; j < invoice.installments.length; j += 1) {
                    const parcel = invoice.installments[j];
                    const itemDate = `${cur.itemDate.getFullYear()}-${String(
                      cur.itemDate.getMonth() + 1,
                    ).padStart(2, '0')}-${String(cur.itemDate.getDate()).padStart(2, '0')}`;

                    if (parcel.dueDate.split('T')[0] === itemDate) {
                      total += parcel.valueInBrl;
                    }
                  }
                }
              }
            }
          }

          return total;
        }, 0);
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(result);
      }

      return '';
    },
  },
};
</script>

<template>
  <li
      class="calendar-item"
      :class="{
      active: active,
      other: otherMonth,
      past: past,
      future: future,
      long: long,
      overview: overview,
      'no-border': noBorder
    }"
  >
    <p class="day">
      {{ day }}
      <span v-if="active" class="text-normal"> hoje</span>
      <span class="totals" v-if="day">{{ getTotals }}</span>
    </p>
    <div class="calendar-item-content">
      <slot/>
    </div>
  </li>
</template>

<style scoped>
.calendar-item {
  display: flex;
  flex-direction: column;
  flex: 0 0 12.5%;
  padding: 0.5rem;
  border-bottom: 1px solid #F4F7F9;
  border-right: 1px solid #F4F7F9;
  /* overflow: auto; */
  /* aspect-ratio: 1/1; */
  min-height: 246px;
}

.calendar-item.overview {
  background-color: #FCFDFD;
  border-right: 0;
}

.calendar-item.long {
  aspect-ratio: unset;
  height: 70vh;
}

.calendar-item.past {
  opacity: 0.85;
  background-color: #f5f6f780;
}

.calendar-item.active {
  background-color: #ebf5ff;
}

.calendar-item.other .day {
  color: #aaaaaa;
}

.calendar-item.no-border {
  border: 0;
}

.calendar-item .calendar-item-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  word-break: break-all;
}

.calendar-item .day {
  font-weight: 600;
  font-size: 0.8rem;
  color: #6a6a6a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.totals {
  color: black;
}
</style>
